export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const USER_SIGNED_UP = 'USER_SIGNED_UP';
export const LOADING = 'LOADING';
